import React, {FC, ReactNode, RefObject} from 'react';

interface IPrintSurveyTakerProps {
  children: ReactNode;
  printRef: RefObject<HTMLDivElement>;
}

export const PrintSurveyTaker: FC<IPrintSurveyTakerProps> = ({printRef, children}) => (
  <div style={{position: 'absolute', width: '100%'}} ref={printRef}>
    {children}
  </div>
);
